
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useProveedorXID } from '../../../hooks';
import { DisenioPaginas } from '../../layout';
import { CargandoMedio, FormCreateUpdateProveedor } from '../../components';
import { useCiudadesStore } from '../../../store';





export const CrearActualizarProveedor = () => {

    const { id } = useParams();
    const { proveedorXIDQuery } = useProveedorXID(id);
    const data = proveedorXIDQuery?.data;
    const { startListadoCiudades } = useCiudadesStore();
    

    useEffect(() => {
        if (data?.departamento) {
            startListadoCiudades(data.departamento);
        }
    }, [data?.departamento]);



    const initialState = (proveedorXIDQuery?.data)
        ? { 
            nombre: data.nombre,
            email: data.email || '',
            nit: data.nit || '',
            formaPago: data.formaPago || '',
            diasCredito: data.diasCredito || '',
            departamento: data.departamento || '',
            ciudad: data.ciudad || '',
            movil: data.movil || '',
            direccion: data.direccion || '',
        }
        : { 
            nombre: '',
            email: '',
            nit: '',
            formaPago: '',
            diasCredito: '',
            departamento: '',
            ciudad: '',
            movil: '',
            direccion: '',
        }




    return (

        <DisenioPaginas titulo={`${(id != 'new') ? 'Actualizar' : 'Crear'} Proveedor`} url={1} add={false} subtitulo="Información de proveedor">
            {(proveedorXIDQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Proveedor..." />
            :   <FormCreateUpdateProveedor initialState={initialState} />
            }
        </DisenioPaginas>
    )   
}
